import { Picture, PictureSource } from '@/models/Muffin/picture';
import { BlockItemVideo } from '@/models/Blocks/Itens/Types/block-item-video';
import { BlockItem } from '@/models/Blocks/Itens/block-item';

export class BlockMedia{
    protected _images: Picture|null = null;
    protected _video: BlockItemVideo|null = null;    

    public addImage(url: string, condition: string| null = null, isMain: boolean = false){
        this._images = this._addImage(this._images, url, condition, isMain);
    }

    protected _addImage(images: Picture|null, url: string, condition: string| null = null, isMain: boolean = false){
        if(isMain){
            if(images){
                images.main = url;
            }else{
                images = new Picture(url);
            }
        }else if(condition !== null && condition !== undefined){
            let nrow: PictureSource = {url: url, condition: condition};
            if(!images){
                images = new Picture(undefined,[nrow]);
            }else{
                if(!images.sources){
                    images.sources = new Array<PictureSource>();
                }
                images.sources.push(nrow);
            }
        }
        return images;
    }

    public clearImages(){
        this._images = null;
    }

    public setVideo(video: string, poster: string|undefined = undefined) {
        this._video = {video: video, poster: poster};
    }

    public set video(video: BlockItemVideo|null){
        this._video = video;
    }

    public get video(): BlockItemVideo|null{
        return this._video;
    }

    public get images():Picture|null{
        return this._images;
    }

    public set images(value: Picture|null){
        this._images = value;
    }
}

function applyMixins(derivedCtor: any, constructors: any[]) {
    constructors.forEach((baseCtor) => {
      Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
        Object.defineProperty(
          derivedCtor.prototype,
          name,
          Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
            Object.create(null)
        );
      });
    });
}

//Multiple inheritance by typescript documentation (https://www.typescriptlang.org/docs/handbook/mixins.html#alternative-pattern)
class BlockItemMediaDeff extends BlockItem{}
interface BlockItemMediaDeff extends BlockItem, BlockMedia{}
applyMixins(BlockItemMediaDeff, [BlockMedia]);

export class BlockItemMedia extends BlockItemMediaDeff{}